
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "ConversationMessagesResult": [
      "ConversationMessages",
      "UnsupportedRuntime"
    ],
    "OpportunityEvent": [
      "ActionApprovedEvent",
      "ActionDismissedEvent",
      "ActionRejectedEvent",
      "ActionRequestedEvent",
      "AgencyTransferEvent",
      "AlbyUpdateEvent",
      "ApplicationSubmittedEvent",
      "AssignmentChangeEvent",
      "AutomatedFollowUpEvent",
      "BotCommentEvent",
      "BusinessClassCodesChangedEvent",
      "CollaboratorsChangedEvent",
      "CoveragesChangedEvent",
      "CreatedEvent",
      "DesiredEffectiveDateChangeEvent",
      "EmailEvent",
      "FileUploadEvent",
      "GmailMessageEvent",
      "GmailRelayEvent",
      "OutcomeChangeEvent",
      "PolicyRenewabilityChangedEvent",
      "ProductsAddedEvent",
      "ProductsRemovedEvent",
      "RequirementAddedEvent",
      "StatusChangeEvent",
      "SubmissionStatusChangeEvent",
      "TriageAssignmentEvent",
      "UserComment"
    ],
    "OpportunityEventBase": [
      "ActionApprovedEvent",
      "ActionDismissedEvent",
      "ActionRejectedEvent",
      "ActionRequestedEvent",
      "AgencyTransferEvent",
      "AlbyUpdateEvent",
      "ApplicationSubmittedEvent",
      "AssignmentChangeEvent",
      "AutomatedFollowUpEvent",
      "BotCommentEvent",
      "BusinessClassCodesChangedEvent",
      "CollaboratorsChangedEvent",
      "CoveragesChangedEvent",
      "CreatedEvent",
      "DesiredEffectiveDateChangeEvent",
      "EmailEvent",
      "FileUploadEvent",
      "GmailMessageEvent",
      "GmailRelayEvent",
      "OutcomeChangeEvent",
      "PolicyRenewabilityChangedEvent",
      "ProductsAddedEvent",
      "ProductsRemovedEvent",
      "RequirementAddedEvent",
      "StatusChangeEvent",
      "SubmissionStatusChangeEvent",
      "TriageAssignmentEvent",
      "UserComment"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ConversationMessagesResult": [
      "ConversationMessages",
      "UnsupportedRuntime"
    ],
    "OpportunityEvent": [
      "ActionApprovedEvent",
      "ActionDismissedEvent",
      "ActionRejectedEvent",
      "ActionRequestedEvent",
      "AgencyTransferEvent",
      "AlbyUpdateEvent",
      "ApplicationSubmittedEvent",
      "AssignmentChangeEvent",
      "AutomatedFollowUpEvent",
      "BotCommentEvent",
      "BusinessClassCodesChangedEvent",
      "CollaboratorsChangedEvent",
      "CoveragesChangedEvent",
      "CreatedEvent",
      "DesiredEffectiveDateChangeEvent",
      "EmailEvent",
      "FileUploadEvent",
      "GmailMessageEvent",
      "GmailRelayEvent",
      "OutcomeChangeEvent",
      "PolicyRenewabilityChangedEvent",
      "ProductsAddedEvent",
      "ProductsRemovedEvent",
      "RequirementAddedEvent",
      "StatusChangeEvent",
      "SubmissionStatusChangeEvent",
      "TriageAssignmentEvent",
      "UserComment"
    ],
    "OpportunityEventBase": [
      "ActionApprovedEvent",
      "ActionDismissedEvent",
      "ActionRejectedEvent",
      "ActionRequestedEvent",
      "AgencyTransferEvent",
      "AlbyUpdateEvent",
      "ApplicationSubmittedEvent",
      "AssignmentChangeEvent",
      "AutomatedFollowUpEvent",
      "BotCommentEvent",
      "BusinessClassCodesChangedEvent",
      "CollaboratorsChangedEvent",
      "CoveragesChangedEvent",
      "CreatedEvent",
      "DesiredEffectiveDateChangeEvent",
      "EmailEvent",
      "FileUploadEvent",
      "GmailMessageEvent",
      "GmailRelayEvent",
      "OutcomeChangeEvent",
      "PolicyRenewabilityChangedEvent",
      "ProductsAddedEvent",
      "ProductsRemovedEvent",
      "RequirementAddedEvent",
      "StatusChangeEvent",
      "SubmissionStatusChangeEvent",
      "TriageAssignmentEvent",
      "UserComment"
    ]
  }
};
      export default result;
    